import { Component, Input } from '@angular/core'
import {
  MbCheckoutBaseFormPartialComponent
} from '../mb-checkout-base-form-partial/mb-checkout-base-form-partial.component'

@Component({
  selector: 'mb-checkout-location-form-partial',
  templateUrl: './mb-checkout-location-form-partial.component.html',
  styleUrls: ['./mb-checkout-location-form-partial.component.scss']
})
export class MbCheckoutLocationFormPartialComponent extends MbCheckoutBaseFormPartialComponent {

  @Input() streetInformationLabelKey = 'address.street'
  @Input() showPoBoxMessage = false
}
